export  function getHelperText(error: string | undefined): string {
  return error && error !== "Required" ? error : "";
}
